import { CheckCircle2, Circle, ArrowRight, PartyPopper, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SETUP_STEPS } from "@/lib/setupFlow";

export const SetupCard = ({ steps, onContinue, onHide }) => {
  const done = SETUP_STEPS.filter((s) => steps[s.key]).length;
  if (done === SETUP_STEPS.length) {
    return (
      <div className="flex items-center gap-3 px-4 py-3 rounded-xl border border-emerald-200 bg-emerald-50 text-emerald-900"
           data-testid="setup-card-complete">
        <PartyPopper className="w-5 h-5 shrink-0" />
        <div className="flex-1 text-sm"><strong>Penz Kurulumu tamamlandı.</strong> Tüm temel kayıtlarınızı oluşturdunuz.</div>
        <button type="button" onClick={onHide} aria-label="Kapat" data-testid="setup-card-hide"
                className="w-11 h-11 -m-2 flex items-center justify-center rounded-lg text-emerald-800 hover:bg-emerald-100">
          <X className="w-4 h-4" />
        </button>
      </div>
    );
  }
  return (
    <div className="rounded-xl border-2 border-[#055473]/20 bg-white p-4 sm:p-5 shadow-sm" data-testid="setup-card">
      <div className="flex items-baseline justify-between gap-3">
        <h2 className="text-base md:text-lg font-semibold text-slate-900">Penz Kurulumu</h2>
        <span className="text-sm text-slate-500" data-testid="setup-card-progress">{done} / {SETUP_STEPS.length} tamamlandı</span>
      </div>
      <div className="mt-2 h-1.5 rounded-full bg-slate-100 overflow-hidden">
        <div className="h-full bg-[#97C216] transition-[width] duration-500" style={{ width: `${(done / SETUP_STEPS.length) * 100}%` }} />
      </div>
      <ul className="mt-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-x-4 gap-y-1.5">
        {SETUP_STEPS.map((s) => (
          <li key={s.key} className="flex items-center gap-2 text-sm" data-testid={`setup-card-step-${s.key}`}
              data-done={steps[s.key] ? "true" : "false"}>
            {steps[s.key]
              ? <CheckCircle2 className="w-4 h-4 text-[#97C216] shrink-0" />
              : <Circle className="w-4 h-4 text-slate-300 shrink-0" />}
            <span className={steps[s.key] ? "text-slate-500 line-through" : "text-slate-800"}>{s.label}</span>
          </li>
        ))}
      </ul>
      <Button onClick={onContinue} className="mt-4 w-full sm:w-auto h-11 bg-[#055473] hover:bg-[#04445d] text-white"
              data-testid="setup-card-continue">
        Devam Et <ArrowRight className="w-4 h-4 ml-1.5" />
      </Button>
    </div>
  );
};
